import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_1: FaireProductEntity = {
  token: "atc_refined_moma_1",
  type: "product",
  name: "Colorful Espresso Cup Set",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a5e76056339f550390bca3b57d4cc469669ba2f2664b37b4c874a756a0ac57eb.webp",
  priceDollars: 38,
  msrpDollars: 62,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
